import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getFirestore, collection, getDocs, doc, updateDoc } from 'firebase/firestore';
import { FaArrowLeft, FaCheck, FaTimes, FaBoxOpen } from 'react-icons/fa';
import UserInventory from './UserInventory';
import { useFireAuth } from '../FireAuthContext';
import DelayRender from './DelayRender';
import './AdminUsers.css';

const AdminUsers = () => {
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { user, updateUser } = useFireAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUsers = async () => {
      if (user) {
        const db = getFirestore();
        const usersRef = collection(db, 'users');
        const userSnapshot = await getDocs(usersRef);
        const userList = userSnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        setUsers(userList);
      }
    };

    fetchUsers();
  }, [user]);

  const handleAuthToggle = async (userId, currentAuthStatus) => {
    const db = getFirestore();
    const userRef = doc(db, 'users', userId);
    await updateDoc(userRef, {
      authorized: !currentAuthStatus
    });
    setUsers(users.map(user => 
      user.id === userId ? {...user, authorized: !currentAuthStatus} : user
    ));

    if (userId === user.uid) {
      updateUser();
    }
  };

  const openInventoryModal = (user) => {
    setSelectedUser(user);
    setIsModalOpen(true);
  };

  const closeInventoryModal = () => {
    setSelectedUser(null);
    setIsModalOpen(false);
  };

  if (!user) {
    return <div>Loading...</div>;
  }

  return (
    <div className="admin-users-section">
      <div className="admin-container">
        <div className="admin-header">
          <FaArrowLeft className="back-arrow" onClick={() => navigate(-1)} />
          <h2>User Management</h2>
        </div>
        <div className="admin-user-list">
          {users.map(user => (
            <div key={user.id} className="admin-user-card">
              <div className="admin-user-avatar">
                <img src={user.profilePicture} alt={user.name} />
              </div>
              <div className="admin-user-details">
                <h3>{user.name} <span className="admin-club-number">#{user.membershipNumber}</span></h3>
                <p className="admin-user-info">
                  💴 {user.money.toFixed(2)} | 🪙 {user.crypto?.hahumCoin || 0} | {user.membershipStatus}
                </p>
                <p className="admin-user-info">
                  Games Played: {user.gamesPlayed || 0} | Last: {user.lastLogin ? new Date(user.lastLogin.toDate()).toLocaleDateString() : 'N/A'}
                </p>
              </div>
              <div className="admin-user-actions">
                {user.authorized ? (
                  <FaCheck 
                    className="admin-action-icon auth" 
                    onClick={() => handleAuthToggle(user.id, user.authorized)}
                    title="Authorized"
                  />
                ) : (
                  <FaTimes 
                    className="admin-action-icon deauth" 
                    onClick={() => handleAuthToggle(user.id, user.authorized)}
                    title="Not Authorized"
                  />
                )}
                <FaBoxOpen 
                  className="admin-action-icon inventory" 
                  onClick={() => openInventoryModal(user)}
                  title="View Inventory"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
      <UserInventory 
        isOpen={isModalOpen} 
        onRequestClose={closeInventoryModal} 
        selectedUser={selectedUser} 
      />
    </div>
  );
};

export default DelayRender(AdminUsers, 300);
